import React from 'react';
import { Stack } from '@mui/material';
import CusSwitch from '../../../../components/material-ui/CusSwitch';
import { API_USERS } from '../../../../api/users';
import useToast from '../../../../hooks/useToast';

export default function MenuSwitches({ user, setSelectUserFull }) {
  const { successToast } = useToast();

  const userId = user.userId;

  const changeSwitch = (data) => {
    API_USERS.info
      .update({ userId: userId, ...data })
      .then((e) => {
        setSelectUserFull((prev) => ({ ...prev, ...data }));
        successToast('Information updated successfully');
      })
      .catch(console.error);
  };

  return (
    <Stack gap={1} bgcolor={(theme) => theme.palette.grey[100]} p={1} borderRadius={1}>
      <CusSwitch
        label={'Deposits are allowed'}
        checked={user.depositEnabled}
        onChange={() => changeSwitch({ depositEnabled: !user.depositEnabled })}
        withoutPadding
        tooltipText={'Allow/Prohibit making deposits.'}
        fontSize={12}
        sx={{ justifyContent: 'space-between' }}
        disabled={!userId}
      />
      <CusSwitch
        label={'Payments are allowed'}
        checked={user.payoutEnabled}
        onChange={() => changeSwitch({ payoutEnabled: !user.payoutEnabled })}
        withoutPadding
        tooltipText={'Allow/Prohibit creating payout requests.'}
        fontSize={12}
        sx={{ justifyContent: 'space-between' }}
        disabled={!userId}
      />
      <CusSwitch
        label={'In-game betting is allowed'}
        checked={user.gameBetEnabled}
        onChange={() => changeSwitch({ gameBetEnabled: !user.gameBetEnabled })}
        withoutPadding
        tooltipText={'Allow/Prohibit betting and withdrawals from balance in games.'}
        fontSize={12}
        sx={{ justifyContent: 'space-between' }}
        disabled={!userId}
      />
    </Stack>
  );
}
